module.exports = __webpack_public_path__ + "static/phone-contact-f7ff826e05300efdd56040cd2d3478ae.png";